import React, { useState } from "react";
import { Badge, IconButton, Popover, Tooltip, useMediaQuery } from "@mui/material";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import { useDashboardNotifications } from "../../context/DashboardNotificationsContext";
import NotificationFeed from "./NotificationFeed";

const NotificationBell = () => {
  const reduceMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const { unreadCardCount } = useDashboardNotifications();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const hasUnread = unreadCardCount > 0;

  return (
    <>
      <Tooltip title="Announcements">
        <IconButton
          size="large"
          color="inherit"
          aria-label="Dashboard announcements"
          onClick={(e) => setAnchorEl(anchorEl ? null : e.currentTarget)}
          sx={{
            ...(hasUnread && !reduceMotion
              ? {
                  animation: "dashboardBellWiggle 4s ease-in-out infinite",
                  "@keyframes dashboardBellWiggle": {
                    "0%, 92%, 100%": { transform: "rotate(0deg)" },
                    "93%": { transform: "rotate(-12deg)" },
                    "94%": { transform: "rotate(10deg)" },
                    "95%": { transform: "rotate(-8deg)" },
                    "96%": { transform: "rotate(6deg)" },
                    "97%": { transform: "rotate(0deg)" },
                  },
                }
              : {}),
          }}
        >
          <Badge
            badgeContent={unreadCardCount}
            sx={{
              "& .MuiBadge-badge": {
                background: "linear-gradient(135deg, #f97316 0%, #ef4444 100%)",
                color: "#fff",
                fontWeight: 700,
                boxShadow: "0 0 0 2px rgba(0,0,0,0.15)",
                ...(hasUnread && !reduceMotion
                  ? {
                      animation: "dashboardBadgePulse 1.8s ease-in-out infinite",
                      "@keyframes dashboardBadgePulse": {
                        "0%, 100%": { boxShadow: "0 0 0 0 rgba(239,68,68,0.6)" },
                        "50%": { boxShadow: "0 0 0 5px rgba(239,68,68,0)" },
                      },
                    }
                  : {}),
              },
            }}
          >
            <CampaignOutlinedIcon />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { borderRadius: "14px", overflow: "hidden" } }}
      >
        <NotificationFeed />
      </Popover>
    </>
  );
};

export default NotificationBell;
